import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  Output,
} from '@angular/core';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { map, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

@Directive({
  selector: '[appDebounceInput]',
  standalone: true,
})
export class DebounceInputDirective implements AfterViewInit, OnDestroy {
  @Output() public debouncedInput = new EventEmitter<string>();

  inputEvent$!: Observable<any>;
  inputEventSubscription!: Subscription;

  constructor(private readonly el: ElementRef) {}

  ngAfterViewInit(): void {
    this.inputEvent$ = fromEvent(this.el?.nativeElement, 'input').pipe(
      map((event: any) => (event.target as HTMLInputElement).value),
      debounceTime(600),
      distinctUntilChanged(),
      tap(text => this.debouncedInput.emit(text)), // Emit the raw value
    );

    this.inputEventSubscription = this.inputEvent$.subscribe();
  }

  ngOnDestroy(): void {
    this.inputEventSubscription.unsubscribe();
  }
}
